export const languageCode = [
  {
    code: "af-ZA",
    name: "Afrikaans (South Africa)",
  },
  {
    code: "ar-XA",
    name: "Arabic",
  },
  {
    code: "eu-ES",
    name: "Basque (Spain)",
  },
  {
    code: "bn-IN",
    name: "Bengali (India)",
  },
  {
    code: "bg-BG",
    name: "Bulgarian (Bulgaria)",
  },
  {
    code: "ca-ES",
    name: "Catalan (Spain)",
  },
  {
    code: "yue-HK",
    name: "Chinese (Hong Kong)",
  },
  {
    code: "cs-CZ",
    name: "Czech",
  },
  {
    code: "da-DK",
    name: "Danish (Denmark)",
  },
  {
    code: "nl-BE",
    name: "Dutch (Belgium)",
  },
  {
    code: "nl-NL",
    name: "Dutch (Netherlands)",
  },
  {
    code: "en-AU",
    name: "English (Australia)",
  },
  {
    code: "en-IN",
    name: "English (India)",
  },
  {
    code: "en-GB",
    name: "English (United Kingdom)",
  },
  {
    code: "en-US",
    name: "English (United States)",
  },
  {
    code: "fil-PH",
    name: "Filipino (Philippines)",
  },
  {
    code: "fi-FI",
    name: "Finnish (Finland)",
  },
  {
    code: "fr-CA",
    name: "French (Canada)",
  },
  {
    code: "fr-FR",
    name: "French (France)",
  },
  {
    code: "gl-ES",
    name: "Galician (Spain)",
  },
  {
    code: "de-DE",
    name: "German (Germany)",
  },
  {
    code: "el-GR",
    name: "Greek (Greece)",
  },
  {
    code: "gu-IN",
    name: "Gujarati (India)",
  },
  {
    code: "he-IL",
    name: "Hebrew (Israel)",
  },
  {
    code: "hi-IN",
    name: "Hindi (India)",
  },
  {
    code: "hu-HU",
    name: "Hungarian (Hungary)",
  },
  {
    code: "is-IS",
    name: "Icelandic (Iceland)",
  },
  {
    code: "id-ID",
    name: "Indonesian (Indonesia)",
  },
  {
    code: "it-IT",
    name: "Italian (Italy)",
  },
  {
    code: "ja-JP",
    name: "Japanese (Japan)",
  },
  {
    code: "kn-IN",
    name: "Kannada (India)",
  },
  {
    code: "ko-KR",
    name: "Korean (South Korea)",
  },
  {
    code: "lv-LV",
    name: "Latvian (Latvia)",
  },
  {
    code: "lt-LT",
    name: "Lithuanian (Lithuania)",
  },
  {
    code: "ms-MY",
    name: "Malay (Malaysia)",
  },
  {
    code: "ml-IN",
    name: "Malayalam (India)",
  },
  {
    code: "cmn-CN",
    name: "Mandarin Chinese",
  },
  {
    code: "mr-IN",
    name: "Marathi (India)",
  },
  {
    code: "no-NO",
    name: "Norwegian (Norway)",
  },
  {
    code: "pl-PL",
    name: "Polish (Poland)",
  },
  {
    code: "pt-BR",
    name: "Portuguese (Brazil)",
  },
  {
    code: "pt-PT",
    name: "Portuguese (Portugal)",
  },
  {
    code: "pa-IN",
    name: "Punjabi (India)",
  },
  {
    code: "ro-RO",
    name: "Romanian (Romania)",
  },
  {
    code: "ru-RU",
    name: "Russian (Russia)",
  },
  {
    code: "sr-RS",
    name: "Serbian (Serbia)",
  },
  {
    code: "sk-SK",
    name: "Slovak (Slovakia)",
  },
  {
    code: "es-ES",
    name: "Spanish (Spain)",
  },
  {
    code: "es-US",
    name: "Spanish (United States)",
  },
  {
    code: "sv-SE",
    name: "Swedish (Sweden)",
  },
  {
    code: "ta-IN",
    name: "Tamil (India)",
  },
  {
    code: "te-IN",
    name: "Telugu (India)",
  },
  {
    code: "th-TH",
    name: "Thai (Thailand)",
  },
  {
    code: "tr-TR",
    name: "Turkish (Turkey)",
  },
  {
    code: "uk-UA",
    name: "Ukrainian (Ukraine)",
  },
  {
    code: "vi-VN",
    name: "Vietnamese (Vietnam)",
  },
];
